import { Component } from './component-base.js';
import { ThemeBus } from './events-bus.js';
import { EVENTS } from './event-constants.js';

export class DynamicContentComponent extends Component {
    connectedCallback() {
        super.connectedCallback();

        this.contentElement = this.querySelector('[ref="dynamic-source"]');

        if (!this.contentElement) return;

        ThemeBus.addEventListener(EVENTS.variantChange, this.#handleVariantChange);
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        ThemeBus.removeEventListener(EVENTS.variantChange, this.#handleVariantChange);
    }

    #handleVariantChange = (event) => {
        const { variant } = event.detail;
        if (!variant) return;
        this.contentElement.textContent = variant.sku || '';
    };
}

customElements.define('dynamic-content-component', DynamicContentComponent);